import { mapState, mapMutations } from 'vuex'
export default {
    computed: {
        ...mapState({
            state_specification: state => state.specification,
            inputParams: state => state.inputParams,
        })
    },
    mounted() {
        this.renderInputParams()
    },

    methods: {
        ...mapMutations(['INPUT_PARAMS_COMPONENTS', 'INPUT_PARAMS_SYSTEM_CONFIGRATION']),

        renderInputParams () {  // 渲染

            let num = this.state_specification[this.type]

            this.paramsList.map((t, i) => {
                if (i >= num && i != 3) t.disabled = true
            })

        },

        saveParams () { // 保存
            
            let c = this.inputParams.Components
            let s = this.inputParams["System_Configuration"]

            this.paramsList.map(t => {

                if (t.prop) {   // Components
                    c[t.prop] = {
                        Brand: t.Brand,
                        Model: t.Model,
                    }
    
                    t.list.map(t1 => {
    
                        if (t1.prop) {

                            if (t1.System_Configuration) {
                                s[t1.prop] = t1.vModel
                            } else {
                                c[t.prop][t1.prop] = t1.vModel
                                
                                // 如果禁用
                                if (t.disabled) c[t.prop][t1.prop] = '0'
                            }
                        }
                        
                    })
                } else {    // system_configration
                    t.list.map(t1 => {
                        s[t1.prop] = t1.vModel
                    })
                }
            })

            this.INPUT_PARAMS_COMPONENTS(c)

            this.$message({ message: '保存成功', type: 'success' })
        },
    },
}